import React, { useEffect, useState, useCallback } from 'react';

const OnlineStatus = ({ activeTime }) => {
    const [status, setStatus] = useState({ isOnline: false, text: '' });

    const parseServerTime = useCallback((timestamp) => {
        if (!timestamp) return null;
        const utcTimestamp = timestamp.includes('Z') || timestamp.includes('+')
            ? timestamp
            : timestamp.replace(' ', 'T') + 'Z';
        return new Date(utcTimestamp);
    }, []);

    const checkOnlineStatus = useCallback(() => {
        if (!activeTime) {
            setStatus({ isOnline: false, text: '' });
            return;
        }

        const activeDate = parseServerTime(activeTime);
        if (!activeDate) {
            setStatus({ isOnline: false, text: '' });
            return;
        }

        const now = new Date();
        const diffInSeconds = Math.floor((now - activeDate) / 1000);

        let timeAgo;
        if (diffInSeconds <= 5) {
            timeAgo = '5 seconds ago';
        } else if (diffInSeconds <= 15) {
            timeAgo = '15 seconds ago';
        } else if (diffInSeconds <= 30) {
            timeAgo = '30 seconds ago';
        } else if (diffInSeconds <= 50) {
            timeAgo = '50 seconds ago';
        } else if (diffInSeconds < 120) {
            timeAgo = '1 minute ago';
        } else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            timeAgo = `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            timeAgo = `${hours} hour${hours > 1 ? 's' : ''} ago`;
        } else if (diffInSeconds < 604800) {
            const days = Math.floor(diffInSeconds / 86400);
            timeAgo = `${days} day${days > 1 ? 's' : ''} ago`;
        } else {
            timeAgo = activeDate.toLocaleDateString([], { month: 'short', day: 'numeric' });
        }

        setStatus({ isOnline: false, text: timeAgo });
    }, [activeTime, parseServerTime]);

    useEffect(() => {
        checkOnlineStatus();
        const interval = setInterval(checkOnlineStatus, 30000);
        return () => clearInterval(interval);
    }, [checkOnlineStatus]);

    if (!status.text) {
        return <span className="offline-status">Offline</span>;
    }

    return <span className="offline-status">Active {status.text}</span>;
};

export default OnlineStatus;
